import React, { useEffect, useState } from 'react';
import PageContainer from 'containers/PageContainer';
import PaymentMethodView from 'views/PaymentMethodView';
import useDisableReasons from 'hooks/useDisableReasons';
import {useSelector} from 'react-redux';

const PaymentMethodContainer = () => {
  const { changeBankDisableReason } = useDisableReasons();
  const account = useSelector((state) => state.account);
  const [bacs, setBacs] = useState()

  useEffect(()=>{
    account && setBacs(account.payment_methods.bacs[0]);
  },[account])

  const renderFunction = () => {
    return (
      <PaymentMethodView
        changeUsageDisableReason={changeBankDisableReason}
        bacs={bacs}
      />
    );
  };

  return (
    <PageContainer
      logoRef="/overview"
      requiresAccount
      requiresLogin
      displayNavBar
      requiresSubscription
      render={renderFunction}
    />
  );
};

PaymentMethodContainer.displayName = 'PaymentMethodContainer';

export default PaymentMethodContainer;
